import { OrderedMap } from 'immutable';

export const passRate = 'pass_rate';

export const TESTS_PAGE_FILTER_FAILING = 'failing';
export const TESTS_PAGE_FILTER_PASSING = 'passing';

export const TESTS_PAGE_TABS = new OrderedMap({
  all: 'ALL',
  [TESTS_PAGE_FILTER_FAILING]: 'CONSISTENTLY FAILING',
  [TESTS_PAGE_FILTER_PASSING]: 'PASSING TESTS',
});

export const TESTS_PAGE_TABLE_HEADERS = new OrderedMap({
  count: 'Test Count',
  avg_duration: 'Test Duration',
  pass_rate: 'Pass Rate',
});
